import { Trans } from "react-i18next";

const News11 = () => {
    return (
        <Trans
            i18nKey={"Dashboard##news##body##11"}
            components={{
                section: <section />,
                h3: <h3>""</h3>, // fake empty content to avoid warnings
                p: <p />,
                ol: <ol />,
                li: <li />,
                strong: <strong />
            }}
        />
    );
};

export { News11 };
